import React, { useState, useEffect, useContext } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Alert from '@material-ui/lab/Alert';

import { SessionContext } from "../context/session-context";

import getClients from "../functions/getClientList";
import ClientForm from "./ClientForm";
import OrderPanel from "./ClientOrderPanel";

const useStyles = makeStyles({
    root: {

    },
    selectContainer:{
        '& .MuiSelect-select.MuiSelect-select':{
            height: 'calc(100vh - 300px)',
        },
        marginTop:10,
        marginRight:10,
        border: '2px solid #3D3E4F',
    },
    selectObject:{
        width:'100%'
    },
    textItemFont:{
        fontSize:12
    }

  });


export default function ClientsPanel(props) {
    const classes = useStyles();
  
    const [sState, sDispatch] = useContext(SessionContext);
    const [selectedClient, setSelectedClient] = useState([]);
    const [selectedClientID, setSelectedClientID] = useState([]);
    const [clientRows, setClientRows] = useState([]);
    const [filterStr, setFilterStr] = useState('');
    const [hasUpdateRequest, setHasUpdateRequest] = useState(false);

    const [severity, setSeverity] = useState('success');
    const [msg, setMsg] = useState('');
    const [snackOpen, setSnackOpen] = useState(false);


    /**
     * First load
     */
    useEffect(() => {

    getClients(sDispatch);

    },[])

    /**
     * Listerner for client list.
     */
    useEffect(() => {
        if (sState.clientList.length > 0){

          setClientRows(sState.clientList);

          if (hasUpdateRequest){
            setHasUpdateRequest(false);
            setSeverity('success')
            setMsg('Client has been updated.')
            setSnackOpen(true);
          }

        }
      },[sState.clientList])

    
    const refreshCompanyList = () => {
        getClients(sDispatch);
    }


    useEffect(() => {
        if (filterStr.length > 1){

            var filterArray = JSON.parse(JSON.stringify(sState.clientList));
    
            filterArray = filterArray.filter(function (c) {
                return c.companyname.charAt(0).toLowerCase() === filterStr.charAt(0).toLowerCase();
            });

            if (filterStr.length > 1)
                filterArray = filterArray.filter(function (c) {
                    return c.companyname.charAt(1).toLowerCase() === filterStr.charAt(1).toLowerCase();
            });

            if (filterStr.length > 2)
            filterArray = filterArray.filter(function (c) {
                return c.companyname.charAt(2).toLowerCase() === filterStr.charAt(2).toLowerCase();
            });

            if (filterStr.length > 3)
            filterArray = filterArray.filter(function (c) {
                return c.companyname.charAt(3).toLowerCase() === filterStr.charAt(3).toLowerCase();
            });
            setClientRows(filterArray);
        } 

    },[filterStr])

    const handleClearFilter = () => {
        setClientRows(sState.clientList);
    };

    const handleGetCompanyDetail = (event) => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        setSelectedClientID(value);
    }

    useEffect(() => {
        for (let c of clientRows) {
            if (parseInt(c.companyid) === parseInt(selectedClientID)){
                setSelectedClient(c);
                break;
            }
        }   
    },[selectedClientID])


    const handleUpdateRequest = () => {
        setHasUpdateRequest(true);
    }

    const handleSnackClose=()=>{
        setSnackOpen(false);
    }

    return (
        <div className={classes.root}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={snackOpen}
                autoHideDuration={6000}
                onClose={handleSnackClose}
                TransitionComponent={Slide}
                TransitionProps={{ direction: 'down' }}
            >
                <Alert onClose={handleSnackClose} severity={severity}>
                {msg}
                </Alert>
            </Snackbar>
            <Grid container>
                <Grid item xs={12}>
                    <Box className={classes.formLabel} fontWeight="500" fontStyle="italic" fontSize={22} >Company details</Box>
                </Grid>
                <Grid item xs={3}>
                <Box>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="filter" label="Filter Clients List" size="small" margin="dense" variant="outlined" value={filterStr} onChange={e => setFilterStr(e.target.value)}/>
                    <Button className={classes.filterButton} variant="contained" onClick={handleClearFilter} >
                        <Box fontWeight="fontWeightRegular" fontSize={12} >Clear filter</Box>
                    </Button>
                </Box>
                <Box className={classes.selectContainer}>
                    <Select
                    multiple
                    native
                    value={selectedClientID}
                    onChange={handleGetCompanyDetail}
                    className={classes.selectObject}
                    inputProps={{
                        id: 'select-multiple-native',
                    }}
                    >
                    {clientRows.map((item, i) => (
                        <option key={i} value={item.companyid}>
                            {item.status === 'active'?item.companyname:item.companyname+" (Disabled)"}
                        </option>
                    ))}
                    </Select>
                </Box>
                </Grid>
                <Grid item xs={9}>
                    <ClientForm client={selectedClient} updated={handleUpdateRequest}/>
                    <OrderPanel companyid={selectedClientID}/>
                </Grid>
            </Grid>
        </div>
    )
  };
